import React, { useEffect, useState, useCallback } from 'react';
import { Select } from 'legion-ui';
import * as styles from './MultiBrandSection.module.scss';
import SquareIcon from './square.svg';

const MultiBrandSection = ({ activeTheme, handleChangeTheme, tribes }) => {
  const [scrollTop, setScrollTop] = useState(false);
  const [device, setDevice] = useState(false);

  const onScroll = useCallback(
    (e) => {
      let scroler = e.target.documentElement.scrollTop > 550;
      setScrollTop(scroler !== scrollTop ? scroler : scrollTop);
    },
    [setScrollTop, scrollTop]
  );

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
  }, [onScroll]);

  useEffect(() => {
    const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
    setDevice(mobile);
  }, [setDevice]);

  const ComponentSwitch = useCallback(() => {
    return (
      <div className="bx--row">
        <div
          className={`bx--col-lg-12 ${styles['flex']} ${styles['justifyBetween']} ${styles['itemsCenter']} ${styles['row1']}`}
        >
          <div>
            <div className={`${styles['flex']} ${styles['itemsCenter']} ${styles['mb2']}`}>
              <object type="image/svg+xml" data={SquareIcon} aria-label="square icon">
                Square Icon
              </object>
              <h1 id="brand-title" className={styles.title}>
                Selected Theme
              </h1>
            </div>
            <h2 id="brand-description" className={styles.description}>
              Select brand or tribe name to preview style
            </h2>
          </div>
          <div
            className={styles.containerSelect}
            style={{
              position: scrollTop && !device ? 'fixed' : 'none',
              top: 85,
              right: 26,
              zIndex: scrollTop && !device ? 9999 : 'none',
            }}
          >
            <Select
              options={tribes}
              value={{ label: activeTheme.label, value: activeTheme.value }}
              onChange={handleChangeTheme}
            />
          </div>
        </div>
      </div>
    );
  }, [scrollTop, tribes, activeTheme, device, handleChangeTheme]);
  return (
    <div className={`${styles['bg']} ${styles['my8']}`}>
      <div className={`bx--grid`} style={{ marginRight: '7.5rem' }}>
        <ComponentSwitch />
      </div>
    </div>
  );
};

export default MultiBrandSection;
